import React, { Component } from "react";
import {
  Form,
  InputGroup,
  Button,
} from "react-bootstrap";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import {
  IModuleDetailProps,
  IModuleDetailState
} from "../../interfaces/module.interface";
import { AppRoutes } from '../../config';
import { IRootState } from "../../interfaces";
import { moduleDetailRequest } from "../../action/Module";
import Loader from '../../components/Loader/Loader';
import { FrontendUrl } from "../../config";

const queryString = require("query-string");
class Module extends Component<IModuleDetailProps, IModuleDetailState> {
  constructor(props: IModuleDetailProps) {
    super(props);
    this.state = {
      search: "",
      moduleName: "",
      endMessage: "",
      previewCss: "",
      module_id: "",
      subModile_ID: "",      
      moduleCompleted: 0,
      moduleDataList: [],
    };
  }
  componentDidMount = () => {
    const { search } = this.state
    const data = { search }
    this.props.getModuleInfo(data);
    window.scrollTo(0, 0);
  };

  componentDidUpdate = (prevProps: IModuleDetailProps, prevState: IModuleDetailState) => {
    const { moduleDetailReducer } = this.props;

    if (prevProps.moduleDetailReducer !== this.props.moduleDetailReducer) {
      const { moduleData } = moduleDetailReducer;
      //console.log("moduleData",moduleData);
      var modules = [];
      for(var i=0;i<moduleDetailReducer.moduleData.length;i++) {
        //console.log("module List",moduleData[i]);     
        modules.push(moduleData[i])
      }
      this.setState({moduleDataList: modules}); 
    }
    
  };

  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type } = event.target;
    if (type === "checkbox") {
      const { checked } = event.target;
      this.setState({
        ...this.state,
        [name]: checked,
      });
    } else {
      this.setState({
        ...this.state,
        [name]: value,
      });
    }
  };

  handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const { search } = this.state;
    const data = {
      search
    }
    const { getModuleInfo } = this.props;
    if (getModuleInfo) {
      await getModuleInfo(data);
    }
  };


  ChangeTopic = (item: any) => {
    if (item.sub_modules && item.sub_modules.length > 0) {
      this.props.history.push(
        AppRoutes.MY_SUB_MODULE.replace(
          ":moduleId",
          item.id

        )
          .replace(
            ":subModuleID", item.sub_modules[0].id
          )
          .replace(
            ":subModuleOrder", item.sub_modules[0].module_order
          )
      )
    }
  }
  
  toggleModules = (moduleDivId: number) => {
    console.log('Clicked!',moduleDivId);
    let moduleSections = document.querySelectorAll("div.subModuleSections");
    for(var i=1;i<=moduleSections.length;i++) {

      var element = document.getElementById("moduleClassName"+i);
      var imgElement = document.getElementById("icon"+i);
      if(element != null && i === moduleDivId) {
        if(element.classList.contains("moduleWelcomeSection")) {
          element.classList.remove("moduleWelcomeSection");
          element.classList.toggle("moduleAlterSection");  
          if(imgElement != null) {
            imgElement.classList.remove("fa-angle-down");
            imgElement.classList.toggle("fa-angle-up"); 
          }

        }
        else {
          if(imgElement != null) {
            imgElement.classList.remove("fa-angle-up");
            imgElement.classList.toggle("fa-angle-down"); 
          }
          element.classList.remove("moduleAlterSection");
          element.classList.toggle("moduleWelcomeSection");  
        }
      } else {
        if(element != null) {
          if(element.classList.contains("moduleAlterSection")) {
            if(imgElement != null) {
              imgElement.classList.remove("fa-angle-up");
              imgElement.classList.toggle("fa-angle-down"); 
            }
            element.classList.remove("moduleAlterSection");
            element.classList.toggle("moduleWelcomeSection"); 
            
            
          }
        }
      }

      if(document.getElementById("module"+i) != null) {
        var y = document.getElementById("module"+i);
        if(y!=null && moduleDivId != i) {
          y.style.display="none";
        } else {
          var x = document.getElementById("module"+moduleDivId);
          if(x!= null) {
            if (x.style.display === "none") {
              x.style.display = "block";
            } else {
              x.style.display = "none";
            }
          }
        }
      }
    }
  
  };


  createSubModules(item: any) {
    // console.log("item--------------------------------",item)
    if (item.sub_modules) {
      return item.sub_modules.map((subitem: any, index1: any) =>  (
          <>
            <div className="subModuleSection" id={`subModuleClassName${index1+1}`}>
            <div className="subModuleText">
              {subitem.module_completed ? (<Form.Check
              custom
              type="checkbox"
              disabled
              name={"moduleCompleted"}
              checked={subitem.module_completed}
              onChange={this.handleChange}
              id="custom-checkbox-module"
              className="float-left moduleCompletedCheck"
            />) : ("")}
              
            <span>{subitem['title']}</span>
            </div>
            <div className="readMoreDiv"><a href={`${FrontendUrl}modules/sub-module/${item.id}/${subitem['id']}/${subitem['module_order']}`} ><Button className="readMoreLink">Read More</Button></a></div>
          </div>
          <div className="subModuleSeparate"></div>
          </>
            ) )
    }
  }
  

  render() {
    const { moduleDetailReducer } = this.props;
    const { search } = this.state;
    const { moduleData } = moduleDetailReducer;
    return (
      <>

<div className="main-section module-custom-main" id="right-container">
      <div><span className="hamburger">Learning Hub</span><span className="hamburger-separator">//</span><span className="hamburger-last">Modules</span></div>
      {!this.state.moduleDataList  ? (
                      <Loader />
                    ) : ( 
                      this.state.moduleDataList.map((item: any, index: any) => ( 
                        <div className="moduleWelcomeSection" id={`moduleClassName${index+1}`}>
                          <div className="circleDiv"><div className="circle">{index+1}</div></div>
                          <div className="moduleNameText">{item && item.name && item.name.length < 180
                                          ? item.name
                                          : item.name.substr(0, 200) + "..."}</div>
                          <div className="subModuleCountText">{item.sub_modules && item.sub_modules.length > 0 ? ` ${item.sub_modules.length}` : ' 0'} Sub Modules </div><div className="subModuleLink" onClick={() => {
                                  this.toggleModules(index+1)}} ><i id={`icon${index+1}`} className="fa fa-angle-down" style={{fontSize:"24px",color:"#000"}}></i></div>
                          <div id={`module${index+1}`} className="subModuleSections" style={{display: "none"}}>
                          {this.createSubModules(item)}
                          </div>
                        </div>
                        ))
                        )} 
</div>

      </>
    );
  }
}

const mapStateToProps: any = (state: IRootState) => ({
  moduleDetailReducer: state.moduleDetailReducer
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    getModuleInfo: (data: any) => {
      dispatch(moduleDetailRequest(data));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Module);
